var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFilePng = function SvgIconFilePng(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.125 11.625v-7.25h7.75v5a1 1 0 0 0 1 1h5v1.25a1 1 0 1 0 2 0v-3a1 1 0 0 0-.293-.707l-5.25-5.25a1 1 0 0 0-.707-.293h-9.75a1.75 1.75 0 0 0-1.75 1.75v7.5a1 1 0 1 0 2 0m9.75-6.586v3.336h3.336z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82 14.423a1 1 0 0 1 1.119.37l1.936 2.712v-2.13a1 1 0 1 1 2 0v5.25a1 1 0 0 1-1.814.581l-1.936-2.71v2.129a1 1 0 1 1-2 0v-5.25a1 1 0 0 1 .695-.952"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.375 15.375a1 1 0 0 1 1-1h1.5a2.875 2.875 0 1 1 0 5.75h-.5v.5a1 1 0 1 1-2 0zm2 2.75h.5a.875.875 0 0 0 0-1.75h-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.316 16.375c.263 0 .52.08.734.23a1 1 0 0 0 1.15-1.636 3.27 3.27 0 0 0-1.89-.594h.003v1l-.004-1h.002c-1.97.001-3.436 1.691-3.436 3.625s1.467 3.625 3.438 3.625c1.264 0 2.335-.71 2.926-1.725a1 1 0 0 0 .136-.503v-.75a1 1 0 0 0-1-1h-.75a1 1 0 0 0-.625 1.78 1.3 1.3 0 0 1-.687.198c-.73 0-1.438-.653-1.438-1.625s.709-1.625 1.438-1.625z"
  }))));
};
export default SvgIconFilePng;